module.exports = __webpack_public_path__ + "img/partners-ru.1cba662.png";